// extracted by mini-css-extract-plugin
export default {"tabs":"ReservationStatusTabs_tabs__SucJ3","tab":"ReservationStatusTabs_tab__5SxYI","tabActive":"ReservationStatusTabs_tabActive__-WTt8","count":"ReservationStatusTabs_count__0O+pT"};